import React from 'react'
import { Button, Dropdown } from 'antd'
import amaliy_1 from '../fayl/amaliy/1.pdf'
import amaliy_2 from '../fayl/amaliy/2.pdf'
import amaliy_3 from '../fayl/amaliy/3.pdf'
import amaliy_4 from '../fayl/amaliy/4.pdf'
import amaliy_5 from '../fayl/amaliy/5.pdf'
import amaliy_6 from '../fayl/amaliy/6.pdf'
import amaliy_7 from '../fayl/amaliy/7.pdf'
import amaliy_8 from '../fayl/amaliy/8.pdf'
import amaliy_9 from '../fayl/amaliy/9.pdf'
import amaliy_10 from '../fayl/amaliy/10.pdf'
import amaliy_11 from '../fayl/amaliy/11.pdf'
import amaliy_12 from '../fayl/amaliy/12.pdf'
import amaliy_13 from '../fayl/amaliy/13.pdf'
import amaliy_14 from '../fayl/amaliy/14.pdf'
import amaliy_15 from '../fayl/amaliy/15.pdf'

const items = [
  {
    key: '1',
    label: (
      <a href={amaliy_1}>
        1-amaliy mashg'ulot.
      </a>
    ),
  },
  {
    key: '2',
    label: (
      <a rel="noopener noreferrer" href={amaliy_2}>
        2-amaliy mashg'ulot.
      </a>
    ),
  }, {
    key: '3',
    label: (
      <a rel="noopener noreferrer" href={amaliy_3}>
        3-amaliy mashg'ulot.
      </a>
    ),
  }, {
    key: '4',
    label: (
      <a rel="noopener noreferrer" href={amaliy_4}>
        4-amaliy mashg'ulot.
      </a>
    ),
  }, {
    key: '5',
    label: (
      <a rel="noopener noreferrer" href={amaliy_5}>
        5-amaliy mashg'ulot.
      </a>
    ),
  }, {
    key: '6',
    label: (
      <a rel="noopener noreferrer" href={amaliy_6}>
        6-amaliy mashg'ulot.
      </a>
    ),
  }, {
    key: '7',
    label: (
      <a rel="noopener noreferrer" href={amaliy_7}>
        7-amaliy mashg'ulot.
      </a>
    ),
  }, {
    key: '8',
    label: (
      <a rel="noopener noreferrer" href={amaliy_8}>
        8-amaliy mashg'ulot.
      </a>
    ),
  }, {
    key: '9',
    label: (
      <a rel="noopener noreferrer" href={amaliy_9}>
        9-amaliy mashg'ulot.
      </a>
    ),
  }, {
    key: '10',
    label: (
      <a rel="noopener noreferrer" href={amaliy_10}>
        10-amaliy mashg'ulot.
      </a>
    ),
  }, {
    key: '11',
    label: (
      <a rel="noopener noreferrer" href={amaliy_11}>
        11-amaliy mashg'ulot.
      </a>
    ),
  }, {
    key: '12',
    label: (
      <a rel="noopener noreferrer" href={amaliy_12}>
        12-amaliy mashg'ulot.
      </a>
    ),
  }, {
    key: '13',
    label: (
      <a rel="noopener noreferrer" href={amaliy_13}>
        13-amaliy mashg'ulot.
      </a>
    ),
  }, {
    key: '14',
    label: (
      <a rel="noopener noreferrer" href={amaliy_14}>
        14-amaliy mashg'ulot.
      </a>
    ),
  }, {
    key: '15',
    label: (
      <a rel="noopener noreferrer" href={amaliy_15}>
        15-amaliy mashg'ulot.
      </a>
    ),
  },
]

const Amaliy = () => {
  return (
    <div>
      <Dropdown menu={{ items }} placement='bottom' arrow={{ pointAtCenter: true }}>
        <Button className='button'>Amaliy mashg'ulotlar</Button>
      </Dropdown>
    </div>
  )
}

export default Amaliy